import { Box, styled, Typography, useTheme } from '@mui/material';
import { colors } from '../../../../../utils/palette';
const ColorPin = styled('div')<{ color?: string; isNotConnected: boolean }>(({ color, isNotConnected, theme }) => ({
  display: 'inline-block',
  backgroundColor: color ? color : 'black',
  width: 12,
  height: 12,
  marginRight: isNotConnected ? 2 : theme.spacing(1),
  marginBottom: -1,
}));

const LabelSpan = styled(Typography)<{ isNotConnected?: boolean }>(({ isNotConnected, theme }) => ({
  fontWeight: 400,
  fontSize: 14,
  marginTop: theme.spacing(1),
  display: 'inline-block',
  marginRight: isNotConnected ? 2 : theme.spacing(1),
}));

const LabelValue = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 12,
  display: 'inline',
}));

const CustomTooltip = (props: any) => {
  const theme = useTheme();
  if (props.active) {
    const tooltipColor = !props.isKo ? colors.success.main : colors.error.main;
    const val = props.payload?.filter((p: any) => p.dataKey === props.tooltip)[0]
      ? props.payload?.filter((p: any) => p.dataKey === props.tooltip)[0]?.value
      : props.payload
        ? props.payload[0]?.value
        : '';

    const color = props.payload?.filter((e: any) => e.name === props.tooltip)[0]
      ? props.payload?.filter((p: any) => p.dataKey === props.tooltip)[0]?.color
      : props.payload
        ? props.payload[0]?.color
        : '';
    return (
      <Box component="div" style={{ padding: theme.spacing(1), textAlign: 'left' }}>
        <Box component="div" className="label" style={{ fontWeight: 600, fontSize: 14 }}>
          {props.custom_label && props.isKo ? 'KO' : props.custom_label && !props.isKo ? 'OK' : props.label?.toUpperCase()}
        </Box>
        <Box component="div" style={{ whiteSpace: 'nowrap' }}>
          <ColorPin isNotConnected={props.tooltip === 'notconnected'} color={props.custom_label ? tooltipColor : color} />
          {!props.custom_label && (
            <LabelSpan isNotConnected={props.tooltip === 'notconnected'}>
              {props.tooltip
                ? props.tooltip === 'notconnected'
                  ? 'Not connected'
                  : props.tooltip.charAt(0).toUpperCase() + props.tooltip.slice(1)
                : props.payload
                  ? props.payload[0].dataKey
                  : ''}
            </LabelSpan>
          )}
          {props.custom_label && <LabelSpan>{props.custom_label}</LabelSpan>}
          <LabelValue>{`${Math.round(parseInt(val?.toString() || '', 10))}${!props.custom_label ? '%' : ''}`}</LabelValue>
        </Box>
      </Box>
    );
  }

  return null;
};

export default CustomTooltip;
